export class FoodList {
  category: FoodListKey;
  diyList: FoodListElement[];

  constructor(category: FoodListKey, diyList: FoodListElement[]) {
    this.category = category;
    this.diyList = diyList;
  }
}

export class FoodListElement {
  count: number;
  diyName: string;
  diyId: number;
  guestDiyIds: number[] = [];
  status: string;
  tray: any;

  constructor(diyName: string, diyId: number, guestDiyId: number, status: string, tray: any) {
    this.count = 1;
    this.diyName = diyName;
    this.diyId = diyId;
    this.guestDiyIds.push(guestDiyId);
    this.status = status;
    this.tray = tray;
  }
}

export class FoodListKey {
  diyTypeName: string;
  diyTypeId: number;
  orderNumber: number;

  constructor(diyTypeName: string, diyTypeId: number, orderNumber: number) {
    this.diyTypeName = diyTypeName;
    this.diyTypeId = diyTypeId;
    this.orderNumber = orderNumber;
  }
}
